import React from "react";
import middleware from "./middleware/middleware";
import Help from "../component/sections/support/Help";

const sitesRoutes = [
  {
    path: "/help",
    render: () => {
      return middleware(["isUserLogin"], <Help />, "Help");
    },
    exact: true,
  },
];

export default sitesRoutes;
